import { render } from "./IndexVente.vue?vue&type=template&id=9a97a152"
import script from "./IndexVente.vue?vue&type=script&lang=js"
export * from "./IndexVente.vue?vue&type=script&lang=js"

import "./IndexVente.vue?vue&type=style&index=0&id=9a97a152&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__